export default __webpack_public_path__ + "static/media/logo.4cd1bb90.png";